import { type Load, error } from '@sveltejs/kit';
import { type Page } from '@agapi/mlc-core';
import { getLocaleFromUrl } from '../../utils';
import { getPage } from '../../clients/storyblok.client';

export interface Response extends Record<string, unknown> {
  pageData: Page;
}

export const load: Load<{ slug: string; }, {}, {}, Response, 'slug'> = async ({ fetch, setHeaders, params, url }): Promise<{pageData: Page}> => {
  setHeaders({ 'Cache-Control': 'max-age=0, s-maxage=86400' }); // Cache for 1 day

  const { language, country } = getLocaleFromUrl(url);
  const page = await getPage(fetch, { slug: `pages/${params.slug}`, locale: language, market: country });
  if (!page) {
    throw error(404, { message: 'Page not found' });
  }

  return { pageData: page };
};
